import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { LeadMagnetCTA } from "@/components/LeadMagnetCTA";
import { AboutSection } from "@/components/AboutSection";
import { ProductCatalog } from "@/components/ProductCatalog";
import { VideoSection } from "@/components/VideoSection";
import { TestimonialsSection } from "@/components/TestimonialsSection";
import { ContactSection } from "@/components/ContactSection";
import { Footer } from "@/components/Footer";
import { FloatingContactButton } from "@/components/FloatingContactButton";
import { Toaster } from "@/components/ui/toaster";

const Index = () => {
  return (
    <div id="top" className="min-h-screen">
      <Header />
      <HeroSection />
      <LeadMagnetCTA />
      <AboutSection />
      <ProductCatalog />
      <VideoSection />
      <TestimonialsSection />
      <ContactSection />
      <Footer />
      <FloatingContactButton />
      <Toaster />
    </div>
  );
};

export default Index;